import ParkPassAPI from "../parkpassAxiosConfig";

export const getParkings = async (parkingType = null) => {
  try {
    const params = parkingType ? { parking_type: parkingType } : {};
    const response = await ParkPassAPI.get("/v1/parkings/", { params });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getParkingById = async (parkingId) => {
  try {
    const response = await ParkPassAPI.get(`/v1/parkings/${parkingId}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const createParking = async (parkingData) => {
  try {
    const response = await ParkPassAPI.post("/v1/parkings/", parkingData);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const updateParking = async (parkingId, parkingData) => {
  try {
    const response = await ParkPassAPI.put(`/v1/parkings/${parkingId}`, parkingData);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const archiveParking = async (parkingId) => {
  try {
    const response = await ParkPassAPI.patch(`/v1/parkings/${parkingId}/archive`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const unarchiveParking = async (parkingId) => {
  try {
    const response = await ParkPassAPI.patch(`/v1/parkings/${parkingId}/unarchive`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getStreetParkings = async () => {
  try {
    const response = await ParkPassAPI.get("/v1/parkings/street/available");
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Parking Lines API
export const getParkingLines = async (parkingId) => {
  try {
    const response = await ParkPassAPI.get(`/v1/lines/parking/${parkingId}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const createParkingLine = async (lineData) => {
  try {
    const response = await ParkPassAPI.post("/v1/lines/", lineData);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const updateParkingLine = async (lineId, lineData) => {
  try {
    const response = await ParkPassAPI.put(`/v1/lines/${lineId}`, lineData);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const deleteParkingLine = async (lineId) => {
  try {
    const response = await ParkPassAPI.delete(`/v1/lines/${lineId}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};
